import Cookies from 'js-cookie';

export const GRID_TOOLTIP_LOCAL_STORAGE_NAME = 'showGridToolTip';
export const GRID_TOOLTIP_COOKIE_NAME = 'showGridToolTip';

export const showGridToolTipLocalStorage = (): boolean => {
  let localStorageToolTipValue;

  try {
    localStorageToolTipValue = localStorage.getItem(GRID_TOOLTIP_LOCAL_STORAGE_NAME);
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error(ex);
  }

  if (
    localStorageToolTipValue === null ||
    localStorageToolTipValue === undefined ||
    localStorageToolTipValue === 'true'
  ) {
    return true;
  }
  return false;
};

export const closeGridToolTipLocalStorage = (): void => {
  try {
    localStorage.setItem(GRID_TOOLTIP_LOCAL_STORAGE_NAME, 'false');
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error(ex);
  }
};

export const getGridToolTip = (): string | undefined => {
  return Cookies.get(GRID_TOOLTIP_COOKIE_NAME);
};

export const showGridToolTipCookie = (): boolean => {
  const cookie = getGridToolTip();
  return typeof cookie === 'undefined' || cookie === 'true';
};

export const closeGridToolTipCookie = (): void => {
  Cookies.set(GRID_TOOLTIP_COOKIE_NAME, 'false', {
    expires: 360,
    sameSite: 'strict',
    secure: true,
  });
};
